export default "__VITE_ASSET__dHJoO6AA__"